import React from 'react';

import {
  Table,
  TableBody,
  TableCol,
  TableHead,
  TableHeader,
  TableRow,
} from 'common/components/Table';

export const CandidateListTableSkeleton: React.FC = () => {
  const getRandomWidth = (min: number, max: number) => {
    const widths = Array.from({ length: max - min + 1 }, (_, i) => `w-${min + i}`);
    return widths[Math.floor(Math.random() * widths.length)];
  };

  return (
    <div className="w-full overflow-x-auto">
      <Table className="table-fixed w-full">
        <TableHead>
          <TableRow isHeader>
            <TableHeader className="w-auto">First Name</TableHeader>
            <TableHeader className="w-auto">Last Name</TableHeader>
            <TableHeader className="w-auto">Phone Number</TableHeader>
            <TableHeader className="w-auto">Region</TableHeader>
            <TableHeader className="w-auto">Location</TableHeader>
            <TableHeader className="w-auto">Stage</TableHeader>
            <TableHeader className="w-auto">Entered Stage At</TableHeader>
            <TableHeader className="w-auto">Time in Stage</TableHeader>
            <TableHeader className="w-auto">Date Applied</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: 10 }).map((_, index) => (
            <TableRow key={index} className="animate-pulse">
              <TableCol>
                <div className={`h-4 bg-gray-200 rounded ${getRandomWidth(12, 20)}`}></div>
              </TableCol>
              <TableCol className="!pl-0">
                <div className={`h-4 bg-gray-200 rounded ${getRandomWidth(16, 24)}`}></div>
              </TableCol>
              <TableCol>
                <div className="h-4 w-28 bg-gray-200 rounded"></div>
              </TableCol>
              <TableCol>
                <div className={`h-4 bg-gray-200 rounded ${getRandomWidth(16, 24)}`}></div>
              </TableCol>
              <TableCol>
                <div className={`h-4 bg-gray-200 rounded ${getRandomWidth(20, 32)}`}></div>
              </TableCol>
              <TableCol>
                <div className="w-fit">
                  <div className={`h-6 bg-gray-200 rounded-full ${getRandomWidth(12, 24)}`}></div>
                </div>
              </TableCol>
              <TableCol>
                <div className="h-4 w-24 bg-gray-200 rounded"></div>
              </TableCol>
              <TableCol>
                <div className={`h-4 bg-gray-200 rounded ${getRandomWidth(12, 20)}`}></div>
              </TableCol>
              <TableCol>
                <div className="h-4 w-20 bg-gray-200 rounded"></div>
              </TableCol>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
